import { render, staticRenderFns } from "./UcDropdownMenu.yaml?vue&type=template&id=2184dd5a&component"
import script from "./UcDropdownMenu.yaml?vue&type=script&lang=ts&component"
export * from "./UcDropdownMenu.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports